import { Component, OnDestroy, OnInit } from '@angular/core';
import { ReportService } from '../../../../../shared/service/report.service';
import { ReportListModel } from '../../../../../shared/models/report.model';
import { SubSink } from 'subsink';
import { AuthenticationService } from '../../../../../shared/service/authentication.service';

@Component({
  selector: 'app-general-reports',
  templateUrl: './general-reports.component.html',
  styleUrls: ['./general-reports.component.scss']
})
export class GeneralReportsComponent implements OnInit, OnDestroy {

  private sub = new SubSink();
  listOfReports: ReportListModel[] = [];
  loading = true;
  searchQuery!: string;
  sortBy = 'desc';

  constructor(private reportService: ReportService, public scopeService: AuthenticationService) {
  }


  getListOfReports() {
    this.loading = true;
    this.sub.sink = this.reportService.getGeneralReportList().subscribe(list => {
      this.listOfReports = list;
      this.loading = false;
    });
  }

  ngOnInit(): void {
    this.getListOfReports();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  sortReports($event: string) {
    this.sortBy = $event;
    if (this.sortBy === 'desc') {
      this.listOfReports.sort((a,b)=>b.time - a.time)
    }
    if (this.sortBy === 'asc') {
      this.listOfReports.sort((a,b)=>a.time - b.time)
    }
    if (this.sortBy === 'useCount') {
      this.listOfReports.sort((a,b)=>b.usedTimes - a.usedTimes)
    }

  }
}
